import { Component } from "preact";
import PropTypes from "prop-types";
import { E_Language } from "@green24/npm-javascript-utils";
import withConfiguration from "../hoc/withConfiguration";
import { GenericLocalizationProvider } from "../../components";

//Languages
import cs from "../../../i18n/cs.json";
import en from "../../../i18n/en.json";

class LocalizationProvider extends Component {
	render({children, configuration}, {}) {
		return (
			<GenericLocalizationProvider
				languages={{
					[E_Language.CZECH]: {cs},
					[E_Language.ENGLISH]: {en},
				}}
				initialLanguage={configuration?.defaultLanguage || E_Language.CZECH}
			>
				{children}
			</GenericLocalizationProvider>
		)
	}

	static get propTypes() {
		return {
			children: PropTypes.any,

			//withConfiguration
			configuration: PropTypes.object,
		}
	}
}

export default withConfiguration(LocalizationProvider);
